"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import clsx from "clsx";

import { createAffiliateLinkIfNeeded } from "@/lib/helpers/createAffiliateLinkIfNeeded";
import { isSection, removeDelimiter } from "@/lib/ingredientFunctions";

export default function RecipeIngredientList({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);
  return (
    <ul
      className="mx-4"
      {...ContentfulLivePreview.getProps({
        entryId: recipe?.sys.id,
        fieldId: "title",
      })}
    >
      {updateRecipe?.ingredients?.map((item: any, index: number) => (
        <li
          key={`ingredient-${index}`}
          className={clsx(
            "list-inside break-inside-avoid",
            isSection(item)
              ? "list-none font-bold leading-loose"
              : "list-disc leading-normal",
          )}
        >
          {isSection(item)
            ? removeDelimiter(item)
            : createAffiliateLinkIfNeeded(item.value)}
        </li>
      ))}
    </ul>
  );
}
